<div id="horizontal-monitor">
  <div class="banner-wrapper">
    <div *ngIf="viewType === 'horizontal'" class="monitor-image clear-margin-padding">
      <div *ngIf="!isVideoCampaign" class="monitor-horz-image-carousel-wrapper">
        <app-image-carousel *ngIf="!isVideoCampaign" [images]="monitorData.attachments"></app-image-carousel>
      </div>
      <div *ngIf="isVideoCampaign" id="horizontalMonitorVideo">
        <monitor-video [attachments]="monitorData.attachments" [mediaId]="monitorData.mediaId"></monitor-video>
      </div>
    </div>
    <div
      *ngIf="monitorData.enableCounters"
      class="monitor-queues clear-margin-padding"
      [ngClass]="{ 'no-advertisement': viewType === 'no_advertisement' }"
    >
      <ul class="side-bar" id="monitor-list" [ngClass]="{ 'v-center': counterLowCount }">
        <li
          class="monitor-data"
          *ngFor="let monitorRow of monitorRows"
          [@tokenIntvertColorFlashAnimation]="{
            value: getMonitorRowAnimationState(monitorRow),
            params: { fontColor: monitorData.tokenFontColor, bgColor: monitorData.backgroundColor }
          }"
          (@tokenIntvertColorFlashAnimation.done)="onMonitorRowAnimationDone(monitorRow)"
          [ngStyle]="{ background: monitorData.backgroundColor, 'border-bottom': '1px solid ' + monitorData.borderColor }"
        >
          <div class="table-cell">
            <span
              class="label-text"
              [ngStyle]="{
                color: monitorData.counterFontColor,
                'font-family': monitorData.counterFontFamily,
                'font-size': monitorData.counterFontSize + 'px'
              }"
              [style.fontFamily]="monitorData.counterFontFamily"
            >
              {{ monitorRow.name | truncate: 12 }}
            </span>
            <span
              class="token-number"
              [ngStyle]="{
                color: monitorData.tokenFontColor,
                'font-family': monitorData.tokenFontFamily,
                'font-size': monitorData.tokenFontSize + 'px'
              }"
              [style.fontFamily]="monitorData.tokenFontFamily"
            >
              {{ monitorRow.tokenNumber || '000' }}
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
